import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../Components/Header/header';
import SideLayout from './sideLayout';
const MainLayout = ({ children }) => {
    const location = useLocation();

    useEffect(() => {
        const isMainLayoutActive = location.pathname === "/Admin/";
        if (isMainLayoutActive) {
            document.body.classList.add('body-with-sidebar');
        } else {
            document.body.classList.remove('body-with-sidebar');
        }
    }, [location.pathname]);

    return (
        <SideLayout>
            <Header />
            <div className='mainbdy'>{children}</div>
        </SideLayout>
    );
};

export default MainLayout;
